import { useTheme } from "@/context/ThemeContext";
import { auctionsLabels } from "@/i18n/labels/auctionsLabels";
import { useLanguage } from "@/context/LanguageContext";
import { NativeSelectField } from "@/components/native/NativeSelectField";

interface SortSelectorProps {
  sortBy: string;
  onSortChange: (value: string) => void;
}

const SORT_VALUES = [
  "createdAt-desc",
  "price-asc",
  "price-desc",
  "year-desc",
  "year-asc",
  "mileage-asc",
  "mileage-desc",
  "make-asc",
  "make-desc",
  "endDate-desc",
  "endDate-asc",
] as const;

const SortSelector = ({ sortBy, onSortChange }: SortSelectorProps) => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const labels = auctionsLabels(language);
  const isDark = theme === "dark";

  const labelFor = (value: string) => {
    const map: Record<string, string> = {
      "createdAt-desc": labels.sort.createdAtDesc,
      "price-asc": labels.sort.priceAsc,
      "price-desc": labels.sort.priceDesc,
      "year-desc": labels.sort.yearDesc,
      "year-asc": labels.sort.yearAsc,
      "mileage-asc": labels.sort.mileageAsc,
      "mileage-desc": labels.sort.mileageDesc,
      "make-asc": labels.sort.makeAsc,
      "make-desc": labels.sort.makeDesc,
      "endDate-desc": labels.sort.endDateDesc,
      "endDate-asc": labels.sort.endDateAsc,
    };
    return map[value] ?? value;
  };

  const options = SORT_VALUES.map((value) => ({
    value,
    label: labelFor(value),
  }));

  return (
    <div className="flex items-center gap-2 bg-card">
      <NativeSelectField
        value={sortBy}
        onValueChange={onSortChange}
        options={options}
        title={labels.sort.placeholder}
        placeholder={labels.sort.placeholder}
        triggerClassName={`w-[120px] md:w-[180px] text-xs md:text-sm ${
          isDark
            ? "bg-black/20 border-white/10 text-white"
            : "bg-white/90 border-gray-200 text-gray-800"
        }`}
      />
    </div>
  );
};

export default SortSelector;
